import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { filter, take } from 'rxjs/operators';
import {
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  IsEnabledProperty,
} from '../../../../../../projects/client';
import { InstallationFeaturesStore } from '../../../../../@store';
import { InstallationService } from '../../../../services/installation.service';

@Component({
  selector: 'app-select-heating-circuit-modal',
  templateUrl: './select-heating-circuit-modal.component.html',
  styleUrls: ['./select-heating-circuit-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectHeatingCircuitModalComponent implements OnInit {
  readonly featurePropertyKey = FeaturePropertyKey;

  allCircuits: Feature<IsEnabledProperty, never>;
  selectedOption: number;

  constructor(
    public installationService: InstallationService,
    private installationFeaturesStore: InstallationFeaturesStore,
    private cdr: ChangeDetectorRef,
    private dialogRef: MatDialogRef<SelectHeatingCircuitModalComponent>
  ) {}

  ngOnInit(): void {
    this.selectedOption = null;

    this.installationFeaturesStore
      .selectInstallationDeviceFeature(FeatureNames.circuits)
      .pipe(
        filter((entry) => !!entry),
        take(1)
      )
      .subscribe((_circuits: Feature<IsEnabledProperty, never>) => {
        this.allCircuits = _circuits;
        this.cdr.markForCheck();
      });
  }

  onHcOptionSelect(hcOption: number): void {
    this.selectedOption = hcOption;
  }

  onConfirm(): void {
    this.dialogRef.close({
      heatingCircuitId: Number(this.selectedOption),
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
